import { useLang } from 'hooks/lang';

import { useProjectProfile } from '../context';

import { Drawer, DropdownMenu, IconButton, ResponsiveRender } from 'components/Blocks';
import { SettingsIcon } from 'components/Icons';

// Only these actions will work properly
// always import them to enable, watch for other on possible errors
import './AddCountry';
import './AddService';
import './CancelProject';
import './ChangeInvoiceOwner';
import './ChangeProjectOwner';
import './ChangeProjectTeam';
import './DateChange';
import './ManageCosts';
import './PDF';
import './PDFChoice';
import './ProjectDetails';
import './ProjectFiles';
import './ProjectLogs';
import './ReactivateProject';

import { OptionModal } from './Modal';
import { ProjectOptionGroup } from './OptionGroup';
import { ProjectOptionShortcuts } from './Shortcuts';

export function ProjectOptions() {
  const { t } = useLang();
  const { project } = useProjectProfile();

  if (!project) return null;

  const items = (
    <>
      <ProjectOptionGroup options={['DETAILS', 'FILES', 'LOGS']} />

      <ProjectOptionGroup
        title={t('manage')}
        options={['ADD_SERVICE', 'ADD_COUNTRY', 'MANAGE_COSTS']}
        addDivisor
      />

      <ProjectOptionGroup
        title={t('change')}
        options={['CHANGE_OWNER', 'CHANGE_INVOICE_OWNER', 'CHANGE_DATE', 'CHANGE_TEAM']}
        addDivisor
      />

      <ProjectOptionGroup
        title="PDF"
        options={['DOWNLOAD_SIMPLE_PDF', 'DOWNLOAD_SERVICE_BREAKDOWN_PDF', 'CHOOSE_PDF']}
        addDivisor
      />

      <ProjectOptionGroup options={['CANCEL_PROJECT', 'REACTIVATE_PROJECT']} addDivisor />
    </>
  );

  return (
    <>
      <OptionModal />

      <ProjectOptionShortcuts />

      <ResponsiveRender
        defaultContent={
          <DropdownMenu
            triggerIcon={<SettingsIcon />}
            tooltipContent={t('project-options')}
            align="start"
            title={t('project-options')}
          >
            {items}
          </DropdownMenu>
        }
        responsiveContent={
          <Drawer
            title={t('project-options')}
            className="max-h-[80vh] overflow-y-auto"
            gap="2"
            trigger={
              <IconButton size="small">
                <SettingsIcon />
              </IconButton>
            }
          >
            {items}
          </Drawer>
        }
      />
    </>
  );
}
